import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import TranslateContainer from 'challenge/common/TranslateContainer';

import { mainText, subText } from 'utils/translate';
import { toCo2Kg } from 'utils/common';

import Lab115B from 'dc/Lab115B';

import { useText, useFormatNumber, useConfig } from 'common/hooks';

import { Wrapper, Header, NumberWrapper, StatsContainer } from './elements';

import { Translate } from 'common/types';

type Props = {
  readonly translate: Translate;
};

const deps = {
  organisationName: state.challenge.campaign.organisation.name,
  totalCo2: state.challenge.stats.total.challenge.co2,
};

export function TotalInsights({
  organisationName,
  totalCo2,
  translate,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const formatNumber = useFormatNumber();
  const { staticUrl, translateImagePath } = useConfig();

  return (
    <Wrapper>
      <Header
        title={t('challenge.ChaPaD24B.ChaStat1D.saving_total', {
          organisationName,
        })}
      />
      <NumberWrapper>
        <Lab115B
          icon={'icon-leaf'}
          label={t('challenge.kgCO2e')}
          value={formatNumber(toCo2Kg(totalCo2), 2)}
        />
      </NumberWrapper>
      <StatsContainer>
        <TranslateContainer
          loader={!translate}
          loaderText={t('challenge.ChaPaD24B.ChaStat1D.loading_translation')}
          translateImageUrl={staticUrl + translateImagePath}
          mainText={mainText(t, translate?.data)}
          subText={subText(t, translate?.data)}
          translate={{
            ...translate?.data,
            units:
              translate?.data?.units &&
              t(`translate.units.${translate?.data?.units}`),
          }}
        />
      </StatsContainer>
    </Wrapper>
  );
}

export default connect<Props, typeof deps>(deps, TotalInsights);
